<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-divider content-position="left"><span style="font-size: 30px">基础信息</span></el-divider>
      <el-row>
        <el-col :span="8">
          <el-form ref="form" label-width="180px">
            <el-form-item label="订单号:">
              {{order.orderNo}}
            </el-form-item>
            <el-form-item label="创建时间:">
              {{order.createTimeStr}}
            </el-form-item>

            <el-form-item label="备注:">
              {{order.note}}
            </el-form-item>
          </el-form>
        </el-col>

        <el-col  :span="8">
          <el-form ref="form" label-width="180px">
            <el-form-item label="创建者帐号:">

                    <span v-if="order.creatConsumer != null">
                      {{order.creatConsumer.nickName}}(用户)
                    </span>
              <span v-else-if="order.createdUser != null">
                      {{order.createdUser.account}}(员工)
                    </span>
            </el-form-item>


          </el-form>
        </el-col>
        <el-col  :span="8">
          <el-form ref="form" label-width="180px">
            <el-form-item label="餐桌:" >
              <span v-if="order.plan"  style="color: red">预点单 (用餐时间：{{order.startTime}})</span>
              <span v-else  style="color: green">{{order.tableNumber}}</span>
            </el-form-item>
            <el-form-item label="就餐人数:">
              {{order.peopleNum}}人
            </el-form-item>

          </el-form>
        </el-col>
      </el-row>
      <br/>
      <el-divider content-position="left"><span style="font-size: 30px">支付信息</span></el-divider>
      <el-row>
        <el-col :span="8">
          <el-form ref="form" label-width="180px">
            <el-form-item label="总金额（￥）:">
              {{order.totalPrice/100}}元
            </el-form-item>
            <el-form-item label="优惠券:" v-if="order.couponPrice > 0">
              {{order.couponPrice/100}}元
            </el-form-item>
            <el-form-item label="餐位费:" v-if="order.mealCost > 0">
              {{order.mealCost/100}}元
            </el-form-item>

          </el-form>
        </el-col>
        <el-col :span="8">
          <el-form ref="form" label-width="180px">
            <el-form-item label="实付金额（￥）:">
              {{order.finalPrice/100}}元
            </el-form-item>
            <el-form-item label="三方订单号:" v-if="order.outOrderNo != null">
              {{order.outOrderNo}}
            </el-form-item>
            <el-form-item label="订单状态:">
              {{order.statusStr}}
            </el-form-item>
          </el-form>
        </el-col>
        <el-col  :span="8">
          <el-form ref="form" label-width="180px"  v-if="order.payStatus > 1 && order.payStatus != 5">
            <el-form-item label="支付时间:">
              {{order.payTimeStr}}
            </el-form-item>
            <el-form-item label="支付方式:">
              {{order.payTypeStr}}
            </el-form-item>
            <el-form-item label="支付帐号:"  v-if="order.payUser != null">
              {{order.payUser.account}}
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <br/>
      <el-divider content-position="left"><span style="font-size: 30px">订单明细</span></el-divider>
      <el-table
        v-if="order.type == 1"
        :data="goodsData"
        style="width: 100%"
        v-loading="loading">
        <el-table-column
          label="菜名"
          prop="goodsName">
        </el-table-column>

        <el-table-column
          label="编号"
          prop="goods.number">
        </el-table-column>

        <el-table-column
          label="数量"
          prop="count">
        </el-table-column>

        <el-table-column
          label="金额"
          :formatter="totalPriceFormat">
        </el-table-column>

        <el-table-column
          label="备注"
          :formatter="noteFormat"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.payStatus == 2" style="color: red">已退款</span>
            <span v-else-if="scope.row.payStatus == 3"  style="color: red">已取消</span>
            <span v-else  style="color: green">正常</span>
          </template>
        </el-table-column>


      </el-table>



    </div>

  </div>
</template>

<script>
    export default {
        data(){
            return {
                uploadUrl:window.server.baseUrl+'/common/imageUpload',
                loading:false,
                order_id:0,
                order:{
                      id:0,
                      number:"",
                      createTimeStr:"",
                      payTime:"",
                      payTimeStr:""
                  },
              goodsData: [],
              totalPrice:0,
              keyword:"",

              chooseOrderGoods:{},
              noteDialogTableVisible:false,
            }
        },
        created(){
            //
          this.order_id = this.$route.query.order_id;
          this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/super_admin/orders', {order_id:this.order_id}, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.order = res.data.orders.content[0];
                    that.order.createTimeStr = this.dateTimeFormat(that.order.createTime);
                    if(that.order.payTime != null && that.order.payTime != ""){
                      that.order.payTimeStr = this.dateTimeFormat(that.order.payTime);
                    }

                    that.initGoodsData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },
            initGoodsData(){
              this.loading = true;
              var that = this;
              that.$api.get('/super_admin/orders/orderGoods', {order_id:that.order.id}, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.goodsData = res.data.orderGoods;
                    that.totalPrice = 0;
                    that.goodsData.forEach(function(value,i){
                      that.totalPrice += (value.goods.sell_price * value.count);
                    });
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },

            statusFormat(row,column){
                //return row.status == 2?"上架":"下架";
              return row.payStatus == 2?"已退款":"正常";
            },
            markerPriceFormat(row,column){
              return row.goods.marker_price/100;
            },
            sellPriceFormat(row,column){
              return row.goods.sell_price/100;
            },
          totalPriceFormat(row,column){
            return row.finalPrice/100;
          },
          noteFormat(row,column){
            let tags = "";
            if(row.goodsTagItems != null && row.goodsTagItems.length > 0) {
              row.goodsTagItems.forEach((tag, index) => {
                tags = tags + "规格：" + tag.name + ",";
              })
              tags = tags+"   其他备注："+row.note;
            }else{
              tags = row.note;
            }
            return tags;
          },
          dateTimeFormat(time) {
            var date=new Date(time);
            var year=date.getFullYear();
            /* 在日期格式中，月份是从0开始的，因此要加0
             * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
             * */
            var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
            var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
            var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
            var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
            var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
            // 拼接
            return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
            //return year+"-"+month+"-"+day;
          },
            in_array(search,array){
              for(var i in array){
                if(array[i]==search){
                  return true;
                }
              }
              return false;
            },



        },
    }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/superAdmin/OrderDetail.vue